import ApiRequest from "../api-request"
import { IRole } from "app/models/role"


export /** @type {*} */
    const RoleRepository = {
        getRoles: () => ApiRequest<null, IRole[]>({
            method: 'GET',
            path: '/roles',
            responseType: 'json'
        }),    
    }